"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[275],{

/***/ 71862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22120);
/* harmony import */ var src_components_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71605);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28908);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


var _excluded = ["type", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var HIT_SLOP = {
  top: 12,
  bottom: 12,
  left: 0,
  right: 0
};

var Button = function Button(props) {
  var type = props.type,
      children = props.children,
      touchableOpacityProps = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props, _excluded);

  var disabled = Boolean(props.disabled);
  var style = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function () {
    return [type !== 'link' && buttonStyles.paddedRoot, buttonStyles[type], disabled && buttonStyles.disabled, touchableOpacityProps.style, props.asCircle && buttonStyles.circular, props.style];
  }, [type, disabled, props.style]);

  var textEl = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    style: [src_constants__WEBPACK_IMPORTED_MODULE_2__/* .TextStyle.T12M */ .pn.T12M, buttonTextStyles[type], props.textStyle],
    children: children
  });

  if (props.onPress != null) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_6___default()), _objectSpread(_objectSpread({
      disabled: disabled,
      hitSlop: HIT_SLOP
    }, touchableOpacityProps), {}, {
      style: style,
      children: [props.leftAdornment, textEl, props.rightAdornment]
    }));
  } else {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_7___default()), {
      style: style,
      children: [props.leftAdornment, textEl, props.rightAdornment]
    });
  }
};

var buttonStyles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8___default().create({
  paddedRoot: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 2 * src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.Unit */ .rj.Unit,
    height: 6 * src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.Unit */ .rj.Unit,
    borderRadius: 3 * src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.Unit */ .rj.Unit
  },
  primary: {
    backgroundColor: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .BrandColor.Bolt */ .Te.Bolt
  },
  secondary: {
    backgroundColor: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .BrandColor.BackgroundGray */ .Te.BackgroundGray
  },
  danger: {
    backgroundColor: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .BrandColor.BackgroundGray */ .Te.BackgroundGray
  },
  disabled: {
    opacity: 0.5
  },
  circular: {
    paddingHorizontal: 0,
    width: 6 * src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.Unit */ .rj.Unit
  },
  link: {}
});
var buttonTextStyles = {
  primary: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .TextStyle.CWhite */ .pn.CWhite,
  secondary: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .TextStyle.CMidnight */ .pn.CMidnight,
  danger: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .TextStyle.CAccentRed */ .pn.CAccentRed,
  link: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .TextStyle.CPositive */ .pn.CPositive
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);

/***/ }),

/***/ 32526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22120);
/* harmony import */ var src_components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66001);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_components_Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71605);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80008);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(moment_timezone__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);











var AUTHORS = {
  'Albert Chuang': {
    name: 'Albert Chuang',
    imageUrl: '/static/images/blog/author/albert1.jpg'
  },
  'Ryan Hill': {
    name: 'Ryan Hill',
    imageUrl: '/static/images/blog/author/ryan1.jpg'
  },
  'OneShop Team': {
    name: 'OneShop Team',
    imageUrl: '/static/images/blog/author/oneshop2.png'
  },
  'Ryan Lucia': {
    name: 'Ryan Lucia',
    imageUrl: '/static/images/blog/author/ryan2.jpg'
  }
};

var BlogPage = function BlogPage(props) {
  var blogContentRootRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(1),
      _React$useState2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_React$useState, 2),
      readingDuration = _React$useState2[0],
      setReadingDuration = _React$useState2[1];

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    var blogContentRoot = blogContentRootRef.current;

    if (blogContentRoot != null) {
      setReadingDuration(Math.ceil(blogContentRoot.innerText.split(/\s+/g).length / 238));
    }
  }, []);
  var formattedDateLabel = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    return moment_timezone__WEBPACK_IMPORTED_MODULE_5___default()(props.dateTime).tz('America/Los_Angeles').format('MMM DD, YYYY');
  }, [props.dateTime]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8___default()), {
    style: styles.root,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(src_components_Layout__WEBPACK_IMPORTED_MODULE_2__/* .EdgeGutter */ .MX, {
      style: styles.column,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        style: [src_constants__WEBPACK_IMPORTED_MODULE_1__/* .TextStyle.T16M */ .pn.T16M, src_constants__WEBPACK_IMPORTED_MODULE_1__/* .TextStyle.CBolt */ .pn.CBolt],
        children: props.tag.toUpperCase()
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        style: [src_constants__WEBPACK_IMPORTED_MODULE_1__/* .TextStyle.T42B */ .pn.T42B, src_constants__WEBPACK_IMPORTED_MODULE_1__/* .GridStyle.MB2Unit */ .Hy.MB2Unit],
        children: props.title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8___default()), {
        style: {
          flexDirection: 'row'
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8___default()), {
          style: {
            width: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(36),
            height: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(36),
            borderRadius: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(18),
            overflow: 'hidden',
            marginRight: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(12)
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
            src: AUTHORS[props.author].imageUrl,
            width: 128,
            height: 128,
            alt: "Photo of ".concat(AUTHORS[props.author].name)
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_8___default()), {
          style: {
            justifyContent: 'center'
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            style: [src_constants__WEBPACK_IMPORTED_MODULE_1__/* .TextStyle.T12M */ .pn.T12M],
            children: AUTHORS[props.author].name
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(src_components_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            style: [src_constants__WEBPACK_IMPORTED_MODULE_1__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_1__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("time", {
              dateTime: props.dateTime,
              children: formattedDateLabel
            }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
              "aria-hidden": "true",
              children: "\xB7"
            }), ' ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("span", {
              children: [readingDuration, " min read"]
            })]
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("main", {
        id: "blog-content-root",
        ref: blogContentRootRef,
        children: props.children
      })]
    })
  });
};

var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_9___default().create({
  root: {
    alignItems: 'center',
    paddingTop: 6 * src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(12)
  },
  column: {
    width: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(760),
    maxWidth: '100%'
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (BlogPage);

/***/ }),

/***/ 45867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22120);
/* harmony import */ var src_components_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71605);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);










var Footer = function Footer() {
  var desktopWidth = (0,react_responsive__WEBPACK_IMPORTED_MODULE_5__.useMediaQuery)({
    minWidth: 860
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
    style: styles.root,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
      style: [desktopWidth && src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.FLDR */ .Hy.FLDR, styles.contentColumn, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MB4Unit */ .Hy.MB4Unit],
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
        style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.FLDR */ .Hy.FLDR, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.FLF1 */ .Hy.FLF1],
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
          style: styles.footerColumn,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
            style: styles.edgeGutter,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: styles.navLogo,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: "/static/images/nav-logo.png?v=1",
                width: 294,
                height: 60
              })
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
          style: styles.footerColumn,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
            style: styles.edgeGutter,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12M */ .pn.T12M, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit],
              children: 'PRODUCT'
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'OneShop'
                  })
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/pricing",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'Pricing'
                  })
                })
              })
            })]
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
        style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.FLDR */ .Hy.FLDR, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.FLF1 */ .Hy.FLF1],
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
          style: styles.footerColumn,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
            style: styles.edgeGutter,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12M */ .pn.T12M, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit],
              children: 'COMPANY'
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/contact",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'Contact'
                  })
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "https://www.workatastartup.com/companies/oneshop",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  target: "_blank",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'Jobs'
                  })
                })
              })
            })]
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
          style: styles.footerColumn,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
            style: styles.edgeGutter,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12M */ .pn.T12M, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit],
              children: 'RESOURCES'
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/policies",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'Marketplace Policies'
                  })
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/blog",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'Blog'
                  })
                })
              })
            })]
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
        style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.FLDR */ .Hy.FLDR, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.FLF1 */ .Hy.FLF1],
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
          style: styles.footerColumn,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
            style: styles.edgeGutter,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12M */ .pn.T12M, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit],
              children: 'SOCIAL'
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "https://www.youtube.com/channel/UC7wKt6XZoagcp8Ry71d4ZWA",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  target: "_blank",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'YouTube'
                  })
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "https://www.facebook.com/oneshopcompany",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  target: "_blank",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'Facebook'
                  })
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "https://www.instagram.com/oneshopcom/",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  target: "_blank",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'Instagram'
                  })
                })
              })
            })]
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
          style: styles.footerColumn,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
            style: styles.edgeGutter,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12M */ .pn.T12M, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit],
              children: 'LEGAL'
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/legal/privacy",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  target: "_blank",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'Privacy'
                  })
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/legal/terms",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  target: "_blank",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'Terms'
                  })
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
              style: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/legal/cancellation",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                  style: {
                    textDecoration: 'none'
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray],
                    children: 'Cancellations'
                  })
                })
              })
            })]
          })
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
      style: styles.disclaimerColumn,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
        style: styles.edgeGutter,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T10R */ .pn.T10R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit],
          children: '© 2024 Inventory Systems, Inc.'
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          style: [src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.T10R */ .pn.T10R, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .TextStyle.CDarkGray */ .pn.CDarkGray, src_constants__WEBPACK_IMPORTED_MODULE_0__/* .GridStyle.MBUnit */ .Hy.MBUnit],
          children: 'List Perfectly is a trademark of ListPerfectly, Inc. Vendoo is a trademark of Vendoo, Inc. Poshmark is a trademark of Poshmark, Inc. Mercari is a trademark of Mercari, Inc. Tradesy is a trademark of Tradesy, Inc. Depop is a trademark of Depop Ltd. Etsy is a trademark of Etsy, Inc. Kidizen is a trademark of Kidizen, Inc. Grailed is a trademark of Grailed, Inc. Heroine is a trademark of Grailed, Inc. eBay is a trademark of eBay, Inc. Facebook is a trademark of Facebook, Inc. Facebook Marketplace is a trademark of Facebook, Inc. OneShop is not endorsed, certified, or affiliated by List Perfectly, Vendoo, mercariBOT, ResellKit, SellerInsight, PrimeLister, Cross List It, Hammoq, ListingJoy, Crosslist, Poshmark, Tradesy, Mercari, Depop, Grailed, Facebook Marketplace, eBay, Kidizen, or Etsy. The names List Perfectly, Vendoo, Crosslist, Poshmark, Tradesy, Mercari, Depop, Grailed, Facebook Marketplace, eBay, Kidizen, and Etsy, as well as related names, marks, emblems and images are registered trademarks of their respective owners.'
        })]
      })
    })]
  });
};

var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_7___default().create({
  root: {
    alignItems: 'center',
    paddingTop: 4 * src_constants__WEBPACK_IMPORTED_MODULE_0__/* .Grid.dp */ .rj.dp(36)
  },
  navLogo: {
    maxWidth: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .Grid.dp */ .rj.dp(100)
  },
  footerColumn: {
    flex: 1,
    marginBottom: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .Grid.dp */ .rj.dp(24)
  },
  contentColumn: {
    width: '100%',
    maxWidth: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .Grid.dp */ .rj.dp(960)
  },
  disclaimerColumn: {
    width: '100%',
    maxWidth: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .Grid.dp */ .rj.dp(960)
  },
  edgeGutter: {
    paddingHorizontal: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .Grid.dp */ .rj.dp(12)
  },
  heroImage: {
    width: '100%'
  },
  featurePreview: {
    padding: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .Grid.dp */ .rj.dp(24),
    borderRadius: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .Grid.dp */ .rj.dp(6),
    backgroundColor: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .NewColor.White */ .Wq.White,
    zIndex: 1
  },
  heroButton: {
    height: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .Grid.dp */ .rj.dp(48),
    borderRadius: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .Grid.dp */ .rj.dp(24)
  },
  actionRow: {
    flexDirection: 'row',
    justifyContent: 'center'
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (Footer);

/***/ }),

/***/ 82969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22120);
/* harmony import */ var src_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71862);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);










var NavBar = function NavBar() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("header", {
    style: {
      position: 'sticky',
      top: 0,
      left: 0,
      width: '100%',
      zIndex: 3,
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(5px)'
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
      style: styles.navRoot,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
        style: styles.navContentRoot,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
          style: styles.logoImg,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
            href: "/",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                src: "/static/images/nav-logo.png?v=1",
                width: 294,
                height: 60,
                priority: true
              })
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
          style: styles.rightColumn,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
            href: "/signup",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(src_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                type: "primary",
                style: styles.signupButton,
                children: 'Sign up'
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
            href: "/login",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(src_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                type: "secondary",
                style: styles.signupButton,
                children: 'Login'
              })
            })
          })]
        })]
      })
    })
  });
};

var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_7___default().create({
  navRoot: {
    alignItems: 'center'
  },
  navContentRoot: {
    width: '100%',
    height: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(66),
    maxWidth: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(1200),
    paddingHorizontal: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(12),
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  logoImg: {
    width: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(117),
    height: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(24)
  },
  rightColumn: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  signupButton: {
    marginLeft: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(12)
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (NavBar);

/***/ })

}]);